import { render, staticRenderFns } from "./ITRequestList.vue?vue&type=template&id=33c65d00"
import script from "./ITRequestList.vue?vue&type=script&lang=js"
export * from "./ITRequestList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports